import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSmoothScroll from "vue-smooth-scroll";
import VueResource from "vue-resource";
import titleMixin from './mixins/titleMixin';
import VueScrollReveal from 'vue-scroll-reveal';

Vue.mixin(titleMixin)

Vue.use(VueSmoothScroll, {
  duration: 1000,
  updateHistory: false
});
// specifying custom default options for all uses of the directive
Vue.use(VueScrollReveal, {
  class: "v-scroll-reveal", // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 1000,
  distance: '15px',
});

Vue.config.productionTip = false;

Vue.use(VueResource);
new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  }
}).$mount("#app");
